import request from '@/modules/base/util/request'
import config from 'config'
import { pickBy } from 'lodash'

const baseUrl = `${config.resourceHost}`

export const buildAndCreateSupplier = (addressData, name) => {
  return new Promise((resolve, reject) => {
    const newSupplierData = {
      name,
      addresses: [{
        ...addressData,
        isDefault: true,
        kind: 'company',
      }],
    }
    SupplierService.create(newSupplierData)
      .then(resolve)
      .catch(reject)
  })
}

export const SupplierService = {
  create: (supplier) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}supplier`, {
        method: 'POST',
        auth: true,
        isConcurrent: true,
        data: supplier,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  edit: (supplier) => {
    return new Promise((resolve, reject) => {
      const { id } = supplier
      request(`${baseUrl}supplier/${id}`, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
        data: supplier,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  updateTags: (supplierId, tags) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}supplier/${supplierId}/tags`, {
        method: 'PUT',
        auth: true,
        isConcurrent: true,
        data: { tags },
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  getById: (id) => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}supplier/${id}`, {
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(error => reject(error))
    })
  },

  find: (searchTerm, offset = null, limit = null, hasEmail = undefined) => {
    const props = { limit, offset, hasEmail }
    const params = pickBy(props, Boolean)
    const query = new URLSearchParams(params)
    const url = `${baseUrl}find/supplier/${encodeURIComponent(searchTerm) || '*'}?${query.toString()}`
    return new Promise((resolve, reject) => {
      request(url, { method: 'GET', auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getAll: (options) => {
    const { offset, limit, searchTerm } = options

    return new Promise((resolve, reject) => {
      const finalOffset = searchTerm ? 0 : offset
      const url = `${baseUrl}supplier?offset=${finalOffset}&limit=${limit}&search=${encodeURIComponent(searchTerm)}`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getAllSsr: (options) => {
    const { startRow = 0, endRow = 20, searchTerm = '', filterModel } = options

    return new Promise((resolve, reject) => {
      const url = `${baseUrl}suppliers`
      const data = { startRow, endRow, searchTerm, filterModel }
      return request(url, { auth: true, isConcurrent: true, method: 'POST', data })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },

  getNextNumber: () => {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}supplier/number`
      return request(url, { auth: true, isConcurrent: true })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },
}

export default SupplierService
